import type { FC } from 'react';
import { ProductInfo, SkeletonAvatar, SkeletonLine } from '@george-labs.com/design-system';

interface Props {
    className?: string;
    horizontal?: true;
    'data-cy'?: string;
}

export const ProductInfoSkeleton: FC<Props> = ({
    className,
    horizontal,
    'data-cy': dataCy = 'product-info-skeleton-loader',
}) => (
    <ProductInfo
        className={className}
        avatar={<SkeletonAvatar size={SkeletonAvatar.SIZE.SIZE_48} animated />}
        type={<SkeletonLine level={3} animated />}
        badges={<SkeletonLine level={6} percentageWidth={15} />}
        horizontal={horizontal}
        data-cy={dataCy}
    />
);
